// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"76a037e8","89":"8bf3702c","98":"48c46a13","277":"5bb861fa","851":"588c39b2","950":"305b2877"}[chunkId] + ".chunk.js";
};